export default ({ FONT_SIZES }) => ({
  title: {
    margin: '0 0 25px',
    ...FONT_SIZES.HEADING_BIG.STYLE
  }
})
